import Api from "shared/service/api/api";

//actions
export const LOAD_ORDERS = "loadOrders";

//mutations
export const SET_ORDERS = "setOrders";

const state = {
  orders: {
    list: [],
    page: 1,
    page_count: 1,
  },
};

const actions = {
  [LOAD_ORDERS](
    { commit },
    { page = 1, search = "", date_from = "", date_to = "", status = "", substate = "", seller_id = "", client_id = null }
  ) {
    Api.callcenter.order
      .all(page, search, date_from, date_to, status, substate, seller_id, client_id)
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }
        commit(SET_ORDERS, response.data);
      })
      .catch((e) => e);
  },
};

const mutations = {
  [SET_ORDERS](state, { list, page, page_count }) {
    state.orders.list = list;
    state.orders.page = page;
    state.orders.page_count = page_count;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
